import type { UseWidget } from '@swf/core/hooks/useWidget';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { WidgetModelConfig } from '@swf/core/store';

import type { SportsPromotionWidgetConfig } from '../config';

import { defaultState } from './defaultState';
import { effects } from './effects';
import { reducers } from './reducers';
import { selectors } from './selectors';
import type { SportsPromotionState } from './types';

export interface SportsPromotionWidgetModel
  extends WidgetModelConfig<SportsPromotionWidgetConfig, SportsPromotionState> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

export const sportsPromotionWidgetModel: SportsPromotionWidgetModel = {
  state: defaultState,
  reducers,
  effects,
  selectors
};
export const useSportsPromotionWidget: UseWidget<
  SportsPromotionWidgetConfig,
  SportsPromotionWidgetModel
> = useWidget;
